/**
 * 插入话题
 * Bai.Zhiming
 * 2019-6-5
 */
angular.module("insertTopicModule", []).
controller("insertTopicCtrl", ["$scope", "$validation", "siteId", "trsHttpService", "$modalInstance", function($scope, $validation, siteId, trsHttpService, $modalInstance) {
    initStatus();
    initData();
    /**
     * [queryTopicById description] 获取话题信息
     * @return {[type]} [description]
     */
    $scope.queryTopicById = function() {
        $validation.validate($scope.insertTopicForm.METADATAID).success(() => {
            if ($scope.status.promise) {
                clearTimeout($scope.status.promise);
                $scope.status.promise = null;
            }
            $scope.status.promise = setTimeout(() => {
                let params = {
                    serviceid: 'mlf_appmetadata',
                    methodname: 'queryTopicById',
                    METADATAID: $scope.data.METADATAID
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(resp => {
                    $scope.data.LISTTITLE = (typeof resp === "object" && resp.LISTTITLE)?resp.LISTTITLE:"";
                });
            }, 800);
        });
    };
    /**
     * [initStatus description] 初始化状态
     * @return {[type]} [description]
     */
    function initStatus() {
        $scope.status = {
            promise: ''
        };
        $scope.data = {};
    }
    /**
     * [initData description] 初始化数据
     * @return {[type]} [description]
     */
    function initData() {
        console.log(siteId);
    }
    /**
     * [confirm description] 确定
     * @return {[type]} [description]
     */
    $scope.confirm = function() {
        $validation.validate($scope.insertTopicForm).success(()=>{
            $modalInstance.close(angular.copy($scope.data));
        });
    };
    /**
     * [cancel description] 取消
     * @return {[type]} [description]
     */
    $scope.cancel = function() {
        $modalInstance.dismiss();
    };
}]);